module.exports = __webpack_public_path__ + "32f161998a8931e5a2535cd6d96bd95c.pdf";